import product from "../assets/product/product.webp";
import { t } from "../services/i18n";

/**
 * Official product image. Spec: exact supplied round image, aspect ratio
 * preserved, never redrawn or distorted. The white card background exists
 * because the current source photo is not transparent (see README).
 */
export default function ProductImage({ small = false }: { small?: boolean }) {
  return (
    <figure className={"product-figure" + (small ? " product-figure--small" : "")}>
      <img src={product} alt={t("common.appName")} width={569} height={622} />
    </figure>
  );
}
